'use strict';

var React = require('react');

var SvgKeyMajor = function SvgKeyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.56.44a1.5 1.5 0 0 1 1.062-.44h2.878a1.5 1.5 0 0 1 1.5 1.5v3.423a.5.5 0 0 1-.5.5h-1.082a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 0-1 1v2l-1.449 1.443a6.5 6.5 0 1 1-5.111-5.724l6.703-6.703zm-6.56 13.56a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }));
};

exports.SvgKeyMajor = SvgKeyMajor;
